/**
 * Approx local currency via Zonos rates (Netsteps proxy).
 * Primary price stays EUR from Liquid | money; appends .approx-price badges only.
 */
(function () {
  'use strict';

  var SESSION_TTL = 10 * 60 * 1000;
  var PRICE_SELECTOR = '[data-cc-cents]:not([data-cc-done]), [data-zonos-price]:not([data-cc-done])';

  var fxCfg = window.__zonosFxConfig || {};
  var cfg = window.__currencyConfig;
  if (!cfg || !fxCfg.proxyUrl) return;

  var PROXY_URL = fxCfg.proxyUrl;

  var COUNTRY_TO_CURRENCY = window.__aesthetCountryToCurrency || {};

  var baseCurrency = String(cfg.presentmentCurrency || cfg.pricedCurrency || cfg.shopCurrency || 'EUR').toUpperCase();
  var baseToApproxRate = null;
  var approxCurrency = '';
  var targetFormat = null;
  var started = false;
  var fetching = false;

  function getHelloCurrency() {
    var code =
      (window.Zonos && window.Zonos.country && window.Zonos.country.currencyCode) ||
      (window.zonosCountry && window.zonosCountry.currencyCode) ||
      '';
    return String(code).toUpperCase();
  }

  function resolveApproxCurrency() {
    var hello = getHelloCurrency();
    if (hello && hello !== baseCurrency) return hello;

    var iso = String(cfg.countryIso || '').toUpperCase();
    var geo =
      iso && COUNTRY_TO_CURRENCY[iso] ? String(COUNTRY_TO_CURRENCY[iso]).toUpperCase() : '';
    if (!geo || geo === baseCurrency) return '';
    return geo;
  }

  function sessionCacheKey(from, to) {
    return 'zonos_rate_' + from + '_' + to;
  }

  function readCache(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (Date.now() - parsed.ts > SESSION_TTL) {
        sessionStorage.removeItem(key);
        return null;
      }
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(key, data) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ data: data, ts: Date.now() }));
    } catch (e) {
      /* quota */
    }
  }

  function formatWithTargetFormat(amount, format) {
    var symbol = (format && format.symbol) || '';
    var thouDel = (format && format.thousandsDelimiter) || ',';
    var intFmt = String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, thouDel);
    return symbol ? symbol + ' ' + intFmt : intFmt;
  }

  function fetchRate(from, to) {
    var cacheKey = sessionCacheKey(from, to);
    var cached = readCache(cacheKey);
    if (cached && cached.rate != null) return Promise.resolve(cached);

    var url = PROXY_URL + '?from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to);
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Proxy HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || data.error) throw new Error(data && data.error ? data.error : 'Invalid response');
        if (data.rate == null) throw new Error('Missing rate');
        writeCache(cacheKey, data);
        return data;
      });
  }

  function getCents(el) {
    var raw = el.getAttribute('data-cc-cents') || el.getAttribute('data-zonos-price');
    var cents = parseInt(raw, 10);
    return isNaN(cents) ? null : cents;
  }

  function formatApprox(cents) {
    var amount = Math.abs(cents) / 100;
    if (targetFormat) {
      try {
        return formatWithTargetFormat(amount, targetFormat);
      } catch (e) {
        /* fall through */
      }
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: approxCurrency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e2) {
      return approxCurrency + ' ' + Math.round(amount);
    }
  }

  function exposeGlobal() {
    window.aesthetCurrency = {
      rate: baseToApproxRate,
      base: baseCurrency,
      approxCurrency: approxCurrency,
      baseToApproxRate: baseToApproxRate,
      formatApprox: formatApprox,
      refreshEl: refreshEl
    };
  }

  function refreshEl(el) {
    if (!el || baseToApproxRate == null) return;
    el.removeAttribute('data-cc-done');
    removeApproxAdjacent(el);
    processEl(el);
  }

  function hasApproxAdjacent(el) {
    var prev = el.previousElementSibling;
    var next = el.nextElementSibling;
    return (
      (prev && prev.classList && prev.classList.contains('approx-price')) ||
      (next && next.classList && next.classList.contains('approx-price'))
    );
  }

  function removeApproxAdjacent(el) {
    var prev = el.previousElementSibling;
    var next = el.nextElementSibling;
    if (prev && prev.classList && prev.classList.contains('approx-price')) prev.remove();
    if (next && next.classList && next.classList.contains('approx-price')) next.remove();
  }

  function convertAll() {
    var els = document.querySelectorAll(PRICE_SELECTOR);
    for (var i = 0; i < els.length; i++) processEl(els[i]);
  }

  function processEl(el) {
    var baseCents = getCents(el);
    if (baseCents == null) return;
    if (el.hasAttribute('data-cc-done')) return;

    el.setAttribute('data-cc-done', '');

    if (needsApprox(el)) {
      var approxCents = Math.round(baseCents * baseToApproxRate);
      insertApprox(el, formatApprox(approxCents));
    }
  }

  function needsApprox(el) {
    if (
      closest(el, '.price__was') ||
      closest(el, '.struck-out-price') ||
      closest(el, '.price-label--catalogue-price') ||
      closest(el, '.unit-price') ||
      closest(el, '.cart-discount')
    ) {
      return false;
    }
    return !!(
      closest(el, '.product-info__price') ||
      closest(el, '.sticky-atc__price') ||
      closest(el, '.mobile-quick-add-modal__price-wrap') ||
      closest(el, '.subtotal')
    );
  }

  function isStickyAtcPrice(el) {
    return !!closest(el, '.sticky-atc__price');
  }

  function positionTooltip(details, tooltip) {
    tooltip.style.left = '';
    tooltip.style.right = '';
    tooltip.style.setProperty('--cc-caret-x', '');

    var btnRect = details.getBoundingClientRect();
    var ttRect = tooltip.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var GUTTER = 8;
    var overflowR = ttRect.right - (vw - GUTTER);

    if (overflowR > 0) {
      var newLeftPx = -6 - overflowR;
      var minLeftPx = GUTTER - btnRect.left;
      if (newLeftPx < minLeftPx) newLeftPx = minLeftPx;
      tooltip.style.left = newLeftPx + 'px';
      tooltip.style.setProperty('--cc-caret-x', btnRect.width / 2 - newLeftPx + 'px');
    }
  }

  function createApproxInfoTooltip() {
    var details = document.createElement('details');
    details.className = 'approx-price__info';

    var summary = document.createElement('summary');
    summary.className = 'approx-price__info-btn';
    summary.setAttribute('aria-label', 'Currency info');
    var glyph = document.createElement('span');
    glyph.setAttribute('aria-hidden', 'true');
    glyph.textContent = 'i';
    summary.appendChild(glyph);

    var tooltip = document.createElement('div');
    tooltip.className = 'approx-price__tooltip small-text';
    tooltip.textContent = 'Final Payment will be in Euros (\u20AC)';

    details.appendChild(summary);
    details.appendChild(tooltip);

    details.addEventListener('toggle', function () {
      if (!details.open) return;
      positionTooltip(details, tooltip);
    });
    window.addEventListener('resize', function () {
      if (details.open) positionTooltip(details, tooltip);
    });

    return details;
  }

  var approxInfoClickAwayBound = false;

  function bindApproxInfoClickAway() {
    if (approxInfoClickAwayBound) return;
    approxInfoClickAwayBound = true;

    document.addEventListener('click', function (e) {
      var openDetails = document.querySelectorAll('.approx-price__info[open]');
      if (!openDetails.length) return;

      for (var i = 0; i < openDetails.length; i++) {
        var details = openDetails[i];
        if (!details.contains(e.target)) {
          details.open = false;
        }
      }
    });
  }

  function isPdpApproxContext(el) {
    return !!(
      closest(el, '.product-info__price') ||
      closest(el, '.sticky-atc__price') ||
      closest(el, '.mobile-quick-add-modal__price-wrap')
    );
  }

  function insertApprox(el, localText) {
    if (hasApproxAdjacent(el)) return;

    var span = document.createElement('span');
    var pdp = isPdpApproxContext(el);
    var stickyAtc = isStickyAtcPrice(el);

    if (pdp) {
      span.className = 'approx-price approx-price--pdp';

      var textNode = document.createElement('span');
      textNode.className = 'approx-price__text';
      textNode.textContent = 'approx. ' + localText;

      span.appendChild(textNode);
      span.appendChild(createApproxInfoTooltip());
    } else {
      span.className = 'approx-price approx-price--cart';
      span.setAttribute('aria-label', 'Approximately ' + localText);

      var tilde = document.createElement('span');
      tilde.className = 'approx-price__tilde';
      tilde.setAttribute('aria-hidden', 'true');
      tilde.textContent = '~';

      var pricePart = document.createElement('span');
      pricePart.className = 'approx-price__text';
      pricePart.textContent = localText;

      span.appendChild(tilde);
      span.appendChild(pricePart);
      span.appendChild(createApproxInfoTooltip());
    }

    el.insertAdjacentElement(stickyAtc ? 'beforebegin' : 'afterend', span);
  }

  function observe() {
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (list) {
      var dominated = false;
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (
            (n.matches && n.matches('[data-cc-cents], [data-zonos-price]') && !n.hasAttribute('data-cc-done')) ||
            (n.querySelector && n.querySelector('[data-cc-cents]:not([data-cc-done]), [data-zonos-price]:not([data-cc-done])'))
          ) {
            dominated = true;
            break;
          }
        }
        if (dominated) break;
      }
      if (dominated && baseToApproxRate != null) requestAnimationFrame(convertAll);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function closest(el, selector) {
    if (el.closest) return el.closest(selector);
    var node = el;
    while (node && node !== document) {
      if (node.matches && node.matches(selector)) return node;
      node = node.parentElement;
    }
    return null;
  }

  function boot() {
    if (started || fetching) return;

    approxCurrency = resolveApproxCurrency();
    if (!approxCurrency) {
      document.documentElement.classList.add('cc-ready');
      return;
    }

    fetching = true;
    fetchRate(baseCurrency, approxCurrency)
      .then(function (data) {
        baseToApproxRate = data.rate;
        targetFormat = data.targetFormat || null;
        exposeGlobal();
        convertAll();
        document.documentElement.classList.add('cc-ready');
        started = true;
        observe();
      })
      .catch(function (err) {
        console.warn('[Zonos FX]', err.message || err);
        document.documentElement.classList.add('cc-ready');
      })
      .finally(function () {
        fetching = false;
      });
  }

  function tryBootWithHelloDelay() {
    bindApproxInfoClickAway();
    boot();
    setTimeout(function () {
      if (!started) boot();
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryBootWithHelloDelay);
  } else {
    tryBootWithHelloDelay();
  }
})();
